import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';

const useGetSystemBranchInsert = isCreateCodding => {
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState({});

  const getBranchInsert = useCallback(
    (params = {}) => {
      const { branchGuid, originGuid, profileGuid } =
        typeof params === 'string' ? { branchGuid: params } : params ?? {};

      // we have to check for profileGuid in create mode, and for branchGuid in edit mode
      if (isCreateCodding) {
        if (!profileGuid) return;
        if (!branchGuid && !originGuid) return;
      } else if (!branchGuid && !profileGuid) {
        return;
      }

      setLoading(true);

      let url;
      let requestParams;

      if (isCreateCodding) {
        url = `Product/Branch/Codding/System/Insert`;
        requestParams = { ProfileGuid: profileGuid };
      } else {
        url = `Product/Branch/Codding/System/Update`;

        requestParams = { ProfileGuid: profileGuid ?? branchGuid };
      }

      axiosClient
        .get(url, { params: requestParams })
        .then(res => {
          if (res?.status === 200 && res?.data?.result) {
            setData(res?.data);
            setError(false);
          } else {
            enqueueSnackbar(res?.message, { variant: 'error' });
            setError(true);
          }
        })
        .catch(() => {
          enqueueSnackbar('خطایی در برقراری ارتباط رخ داد.', {
            variant: 'error',
          });
          setError(true);
        })
        .finally(() => setLoading(false));
    },
    [enqueueSnackbar, isCreateCodding],
  );

  return {
    getBranchInsert,
    getBranchInsertData: data,
    getBranchInsertLoading: loading,
    getBranchInsertError: error && !loading,
    setGetBranchInsertData: setData,
  };
};

export default useGetSystemBranchInsert;
